import { render, staticRenderFns } from "./CustomerSavedCount.vue?vue&type=template&id=272be918&scoped=true"
import script from "./CustomerSavedCount.vue?vue&type=script&lang=js"
export * from "./CustomerSavedCount.vue?vue&type=script&lang=js"
import style0 from "./CustomerSavedCount.vue?vue&type=style&index=0&id=272be918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272be918",
  null
  
)

export default component.exports